import { useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencyValue } from '../../../common/currencyValue';
import { constants } from '../../../common/constants/constants';
import { TotalItem } from './TotalItem';
import {setInstallmentParams, setOnGoingPaymentInstallments} from "../../../store/tenant/slice";
import {useDispatch, useSelector} from "react-redux";
import ServerData from "../../../common/serverData";
import {hideLoader, showLoader} from "../../../store/common/slice";
import ErrorsHandler from "../../../common/errors/handleErrors";
import Money from "../../../common/utils/money";


export function MonthlyCheckoutItem({ payments }) {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    
    const [monthsOpened, setMonthsOpened] = useState(false);
    const currency = useMemo(() => payments[0]?.amount_left?.currency ?? constants.defaultCurrency, []);
    const paymentMethod = useSelector(state => state.tenant.paymentMethod);
    const total = useMemo(() => payments.reduce((acc, p) => acc + p.amount_left?.value, 0), []);
    const installmentParams = useSelector(state => state.tenant.installmentParams.onGoing);
    const installments = useSelector(state => state.tenant.installments.onGoing);
    const buildingId = useSelector(state => state.tenant.buildingID);

    function handleInstallmentsChange(value) {
        dispatch(setOnGoingPaymentInstallments(value));
    }

    useEffect(async () => {
        dispatch(showLoader)
        try {
            const client = new ServerData();
            const paymentsCount = payments.length;
            const paymentType = 'on_going_monthly';
            const amountInCents = Money.roundNumber(total * 100);
            const options = await client.tenants.payments.getInstallmentOptions(buildingId, paymentType,  paymentMethod, amountInCents, { paymentsCount });
            dispatch(setInstallmentParams({ paymentType, params: options }))
        } catch (e) {
            ErrorsHandler.notifyClientError(e);
        } finally {
            dispatch(hideLoader);
        }
    }, [paymentMethod, payments]);

    const renderMonths = (payment, i) => {
        return (
            <div key={i} className='month-info'>
                <div className='year'>{payment.year}</div>
                <div className='month'>{t(`common.months.${payment?.month}`)}</div>
                <CurrencyValue notInCents={true} currency={currency}>{payment?.amount_left?.value}</CurrencyValue>
            </div>
        )
    };

    return (
        <div className='checkout'>
            <div className='checkout-title'>
                {t('payments.onGoing')}
                <span onClick={() => setMonthsOpened(!monthsOpened)} className='show-details'>{t('payments.show_details')}</span>
            </div>
            {monthsOpened && (
                <div className='months-wrapper'>
                    {payments.map((payment, i) => renderMonths(payment, i))}
                </div>
            )}
            <TotalItem 
                currency={currency} 
                total={total}
                installments={installments}
                installmentParams={installmentParams}
                onInstallmentsChange={handleInstallmentsChange}
            />
        </div>
    )
}
